<div class="blog-label rounded-pill bg-white py-1 px-3">
  <span>{{ text }}</span>
</div>
